import { Skeleton } from '../../shared/skeleton'

import { Container, DateWrapper, type CardProps } from './styles'

const CardLoading = ({ modifier = 'default' }: Partial<CardProps>) => (
  <Container modifier={modifier}>
    <div className="blog-card__cover">
      <Skeleton height="13.25rem" image />
    </div>
    <div className="blog-card__content">
      <Skeleton width="45%" text />
      <Skeleton height="3rem" />
      <DateWrapper className="skeleton__wrapper">
        <Skeleton height="1rem" margin="0" width="30%" text />
        <Skeleton height="1rem" margin="0" width="45%" text />
      </DateWrapper>
      <hr />
      <Skeleton height="1.25rem" margin="auto auto 0.75rem" width="70%" text />
    </div>
  </Container>
)

export default CardLoading
